import { useNavigate } from "react-router-dom";
import Button from "../components/common/Button";
import fetusQrImage from "../assets/event-fetus-qr.png";
import childQrImage from "../assets/event-child-qr.png";

const EVENTS = [
  {
    title: "태아보험 소개 이벤트",
    subtitle: "소중한 지인을 소개해 주시면 감사의 마음을 담아 선물을 드립니다.",
    desc: "태아보험 상담이 필요한 지인을 소개해 주세요.",
    path: "/events/fetus",
    qr: fetusQrImage,

    bg: "from-pink-100 via-rose-50 to-white",
    glow: "bg-pink-300/30",
    border: "border-pink-200",
    point: "text-pink-500",
    badge: "bg-pink-500",
    button: "🍼 태아보험 이벤트 바로가기",
  },
  {
    title: "어린이보험 소개 이벤트",
    subtitle: "어린이보험 상담이 필요한 지인을 소개해 주세요.",
    desc: "소개해주신 지인이 가입하시면 감사 선물을 드립니다.",
    path: "/events/child",
    qr: childQrImage,

    bg: "from-sky-100 via-cyan-50 to-white",
    glow: "bg-sky-300/30",
    border: "border-sky-200",
    point: "text-sky-500",
    badge: "bg-sky-500",
    button: "🌈 어린이보험 이벤트 바로가기",
  },
];

export default function ReferralEventsPage() {
  const navigate = useNavigate();

  return (
    <main className="relative overflow-hidden bg-[#f8fafc]">
      {/* background glow */}
      <div className="absolute left-[-120px] top-[-120px] h-[280px] w-[280px] rounded-full bg-pink-200/40 blur-3xl" />
      <div className="absolute bottom-[-120px] right-[-100px] h-[260px] w-[260px] rounded-full bg-sky-200/40 blur-3xl" />

      <section className="relative mx-auto w-full max-w-6xl px-5 py-12 md:px-6 md:py-18">
        {/* header */}
        <div className="mb-10 text-center">
          <div className="inline-flex items-center rounded-full border border-white/60 bg-white/80 px-5 py-2 shadow-sm backdrop-blur">
            <span className="text-xs font-extrabold tracking-[0.18em] text-gray-500">
              GOODRICH PLUS EVENT
            </span>
          </div>

          <h1 className="mt-5 text-[34px] font-black tracking-[-0.06em] text-secondary md:text-[48px]">
            지인 소개 이벤트
          </h1>

          <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-gray-600 md:text-lg">
            소중한 지인을 소개해 주세요.
            <br className="hidden md:block" />
            상담부터 가입까지 다양한 혜택을 제공해드립니다.
          </p>
        </div>

        {/* cards */}
        <div className="grid gap-6 md:grid-cols-2">
          {EVENTS.map((event) => (
            <div
              key={event.path}
              className={`group relative overflow-hidden rounded-[34px] border ${event.border} bg-gradient-to-br ${event.bg} p-6 shadow-[0_18px_50px_rgba(0,0,0,0.08)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_24px_60px_rgba(0,0,0,0.12)] md:p-7`}
            >
              {/* glow */}
              <div
                className={`absolute right-[-40px] top-[-40px] h-[160px] w-[160px] rounded-full blur-3xl ${event.glow}`}
              />

              <div className="relative z-10">
                {/* badge */}
                <div
                  className={`inline-flex rounded-full px-4 py-1 text-xs font-bold tracking-[0.12em] text-white ${event.badge}`}
                >
                  SPECIAL EVENT
                </div>

                {/* title */}
                <h2
                  className={`mt-4 text-[24px] font-black tracking-[-0.05em] ${event.point} md:text-[30px]`}
                >
                  {event.title}
                </h2>

                {/* subtitle */}
                <p className="mt-3 text-[17px] font-bold leading-7 text-gray-900">
                  {event.subtitle}
                </p>

                {/* desc */}
                <p className="mt-2 text-[15px] leading-6 text-gray-600">
                  {event.desc}
                </p>

                {/* qr */}
                <div className="mt-6 rounded-[26px] border border-white/70 bg-white/80 p-4 shadow-[0_8px_30px_rgba(0,0,0,0.06)] backdrop-blur">
                  <div className="flex flex-col items-center">
                    <div className="rounded-3xl bg-white p-3 shadow-sm">
                      <img
                        src={event.qr}
                        alt={`${event.title} QR`}
                        className="h-[150px] w-[150px] object-contain"
                      />
                    </div>

                    <p className="mt-3 text-sm font-semibold text-gray-500">
                      QR 스캔 후 간편하게 신청 가능
                    </p>
                  </div>
                </div>

                {/* button */}
                <Button
                  type="button"
                  variant="secondary"
                  className="mt-5 h-[56px] w-full rounded-2xl text-base font-extrabold shadow-lg transition-transform duration-200 group-hover:scale-[1.01]"
                  onClick={() => navigate(event.path)}
                >
                  {event.button}
                </Button>
              </div>
            </div>
          ))}
        </div>
      </section>
    </main>
  );
}
